import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { Formik } from 'formik'
import { SSOToolSchema } from '../../../lib/schemas'
import * as handleAddSSOIntegration from '../../../store/css-admin/sso-tool/operations'
import { connect } from 'react-redux'
import SSOToolLayout from './SSOToolLayout'

class SSOToolContainer extends Component {
  enableValidation = props => {
    return (
      props.isSubmitting ||
      props.isValidating ||
      !props.isValid ||
      !props.touched
    )
  }

  handleSubmit = async (values, { setSubmitting }) => {
    const { displayName, provider, domains, activeDate, endDate } = values
    await this.props.handleAddSSOIntegration({
      displayName,
      provider,
      domains,
      activeDate,
      endDate,
    })
    setSubmitting(false)
  }

  render() {
    return (
      <Formik
        initialValues={{
          displayName: '',
          provider: '',
          domains: '',
          activeDate: '',
          endDate: null,
        }}
        onSubmit={this.handleSubmit}
        validationSchema={SSOToolSchema}
      >
        {formikProps => {
          return (
            <form onSubmit={formikProps.handleSubmit}>
              <SSOToolLayout
                {...this.props}
                {...formikProps}
                enableSubmit={true}
                enableValidation={this.enableValidation}
              />
            </form>
          )
        }}
      </Formik>
    )
  }
}

const mapStateToProps = ({ addSSOManager }) => {
  return {
    ...addSSOManager,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...handleAddSSOIntegration,
    },
    dispatch,
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SSOToolContainer)
